module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_7042.a4e9607e.png";